import {defineStore} from 'pinia';

const useGlobalStore = defineStore('global', {
    state: () => ({
        isLoading: false,
        /** 스피너 사용 유무 */
        usingSpinner: false,
        message: '',
    }),
    actions: {
        setIsLoadingTrue() {
            this.isLoading = true;
        },
        setIsLoadingFalse() {
            this.isLoading = false;
        },
        showSpinner() {
            this.usingSpinner = true;
        },
        hideSpinner() {
            this.usingSpinner = false;
        },
        setMessage(message: string) {
            this.message = message;
        },
        clearMessage() {
            this.message = '';
        },
    },
});

export default useGlobalStore;
